/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step_Index_DescriptionInputs */

const en_landing_step_index_description = /** @type {(inputs: Landing_Step_Index_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert decades of unstructured research into structured, searchable agentic data.`)
};

/**
* | output |
* | --- |
* | "Convert decades of unstructured research into structured, searchable agentic data." |
*
* @param {Landing_Step_Index_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_step_index_description = /** @type {((inputs?: Landing_Step_Index_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step_Index_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_step_index_description(inputs)
});